export default "__VITE_ASSET__b7a2024f__"